/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import { useUtils } from '../../core/hooks/useUtils';
import {
	getAuthLinkAction,
	loginAction,
	socialAction,
} from '../../store/Auth/action';

interface IOutput {
	state: HookState;
	salesforceLogin(): void;
	handleLogin(googleData: any): void;
	handleLoginWithInvitation(googleData: any, inviteToken: any): void;
}

interface HookState {
	isGoogleLoading: boolean;
	isSalesLoading: boolean;
}

export default function useHook(): IOutput {
	const { dispatch } = useUtils();

	const [state, setState] = useState<HookState>({
		isGoogleLoading: false,
		isSalesLoading: false,
	});

	useEffect(() => {
		const search = window.location.search;
		const params = new URLSearchParams(search).get('token');
		if (params) {
			dispatch(loginAction({ token: params }));
		}
	}, []);

	const salesforceLogin = () => {
		toggleLoader('isSalesLoading');
		const windowReference = window.open();
		dispatch(
			getAuthLinkAction({
				callBack: ({ link }: any) => {
					toggleLoader('isSalesLoading');
					windowReference!.location = link;
				},
			})
		);
	};

	const handleLogin = (googleData: any) => {
		toggleLoader('isGoogleLoading');
		const { tokenId } = googleData;
		dispatch(
			socialAction({
				token: tokenId,
				callBack: () => {
					toggleLoader('isGoogleLoading');
				},
			})
		);
	};

	const handleLoginWithInvitation = (googleData: any, inviteToken: any) => {
		const { tokenId } = googleData;
		toggleLoader('isGoogleLoading');
		dispatch(
			socialAction({
				token: tokenId,
				inviteToken,
				callBack: () => {
					toggleLoader('isGoogleLoading');
				},
			})
		);
	};

	const toggleLoader = (field: keyof typeof state): void => {
		setState(prev => ({
			...prev,
			[field]: !prev[field],
		}));
	};

	return {
		state,
		salesforceLogin,
		handleLogin,
		handleLoginWithInvitation,
	};
}
